import React from "react";
import HomeBanner from "../components/Landing/HomeBanner/HomeBanner";
import SmartSolar from "../components/Landing/SmartSolar/SmartSolar";
import DigitalSolar from "../components/Landing/DigitalSolar/DigitalSolar";
import ProjectDetails from "../components/Landing/ProjectDetails/ProjectDetails";
import ServiceCard from "../components/Landing/ServiceCard/ServiceCard";
import TestimonialCard from "../components/Landing/ServiceCard/TestimonialCard.jsx";
import { Helmet } from "react-helmet-async";
// import Card from "../components/Landing/MiddleCard/Card";

const Landing = () => {
  return (
    <>
      <Helmet>
        {/* Basic SEO */}
        <title>Dental Clinic in Gandhinagar | Best Dentist in Gandhinagar | Dental Clinic Near Me, Dental Clinic in Sector 7 Gandhinagar, Teeth Doctor in Gandhinagar, Dental Clinic in Randesan, Raysan, Sargasan, Kudasan, PDPU, Koba, Gift City, Por, Adalaj, Palaj, Lavarpur, Shahpur, Ratanpur, Raksha Shakti, Vavol </title>
        <meta
          name="description"
          content="Dental Clinic in Gandhinagar-Gujarat, Dr. Pragnesh Solanki is Best Dentist that offers advanced painless root canals, premium dental implants, cosmetic dentistry, braces, veneers, teeth whitening, and full-mouth reconstruction. Book your appointment today!"
        />
        <meta
          name="keywords"
          content="Mahi dental clinic, Mahi dental clinic gandhinagar, dental clinic in Gandhinagar, best dentist in Gandhinagar, Mahi Dental Clinic - dental clinc in Gandhinagar, Best price for dental implants in Gandhinagar, root canal Gandhinagar, braces Gandhinagar, veneers Gandhinagar, crowns Gandhinagar, dentures Gandhinagar, laser dentistry Gandhinagar, teeth whitening Gandhinagar, pediatric dentist Gandhinagar, cosmetic dentist Gandhinagar"
        />
        <meta name="robots" content="index, follow" />
        <meta name="publisher" content="Mahi Dental Clinic" />

        {/* Canonical */}
        <link rel="canonical" href="https://www.mahidentalclinic.com" />

        {/* Open Graph */}
        <meta property="og:title" content="Mahi Dental Clinic, Dentist in Gandhinagar, Best Dental Clinic in Gandhinagar, Dental Clinic Near Me, Dental Clinic in Sector 7 Gandhinagar, Teeth Doctor in Gandhinagar, Dental Clinic in Randesan, Raysan, Sargasan, Kudasan, PDPU, Koba, Gift City, Por, Adalaj, Palaj, Lavarpur, Shahpur, Ratanpur, Raksha Shakti, Vavol" />
        <meta property="og:description" content="2000+ patients trust Mahi Dental Clinic for dental implants, root canals, braces, veneers, teeth whitening, and cosmetic dentistry in Gandhinagar, Gujarat." />
        <meta property="og:image" content="https://res.cloudinary.com/dj7gzc2mb/image/upload/v1759592481/mahidentallocation_qg7coc.webp" />
        <meta property="og:url" content="https://www.mahidentalclinic.com" />
        <meta property="og:type" content="website" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content="Mahi Dental Clinic, Dentist in Gandhinagar, Best Dental Clinic in Gandhinagar, Dental Clinic Near Me, Dental Clinic in Sector 7 Gandhinagar, Teeth Doctor in Gandhinagar, Dental Clinic in Randesan, Raysan, Sargasan, Kudasan, PDPU, Koba, Gift City, Por, Adalaj, Palaj, Lavarpur, Shahpur, Ratanpur, Raksha Shakti, Vavol" />
        <meta property="og:description" content="Experience world-class dental treatments at Mahi Dental Clinic, Gandhinagar. From routine checkups to advanced surgery." />
        <meta property="og:image" content="https://res.cloudinary.com/dj7gzc2mb/image/upload/v1759592481/mahidentallocation_qg7coc.webp" />
        <meta property="og:url" content="https://www.mahidentalclinic.com" />
        <meta property="og:site_name" content="Mahi Dental Clinic" />
        <meta property="og:locale" content="en_IN" />
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Mahi Dental Clinic, Dentist in Gandhinagar, Best Dental Clinic in Gandhinagar, Dental Clinic Near Me, Dental Clinic in Sector 7 Gandhinagar, Teeth Doctor in Gandhinagar, Dental Clinic in Randesan, Raysan, Sargasan, Kudasan, PDPU, Koba, Gift City, Por, Adalaj, Palaj, Lavarpur, Shahpur, Ratanpur, Raksha Shakti, Vavol" />
        <meta name="twitter:description" content="Providing advanced dental care including implants, root canals, braces, veneers, and cosmetic dentistry in Gandhinagar." />
        <meta name="twitter:image" content="https://res.cloudinary.com/dj7gzc2mb/image/upload/v1759592481/mahidentallocation_qg7coc.webp" />

        {/* Local Business Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": ["Dentist", "Dental Clinic"],
            "name": "Mahi Dental Clinic",
            "url": "https://www.mahidentalclinic.com",
            "logo": "https://www.mahidentalclinic.com/assets/mahi_dental_logo.jpg",
            "image": "https://res.cloudinary.com/dj7gzc2mb/image/upload/v1759592481/mahidentallocation_qg7coc.webp",
            "telephone": "+919978914926",
            "priceRange": "₹₹",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": " Block C, Sector 7, near Pathikasharam Bus station gandhinagar gujarat",
              "addressLocality": "Gandhinagar",
              "addressRegion": "Gujarat",
              "addressCountry": "IN",
              "postalCode": "382007"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 23.2151,
              "longitude": 72.6323
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.9",
              "reviewCount": "2450"
            },
            "medicalSpecialty": [
              "DentalImplants",
              "Endodontics",
              "Orthodontics",
              "Prosthodontics",
              "CosmeticDentistry",
              "LaserDentistry"
            ],
            "department": [
              ...[
                "Dental Implants",
                "Root Canal Treatment",
                "Braces & Aligners",
                "Veneers",
                "Crowns & Bridges",
                "Dentures",
                "Laser Dentistry",
                "Teeth Whitening",
                "Full Mouth Reconstruction",
                "Pediatric Dentistry",
                "TMJ Treatment",
                "Fluoride Treatment",
                "Gum Disease Treatment",
                "Preventive Sealants"
              ].map(service => ({
                "@type": "MedicalProcedure",
                "name": service
              }))
            ],
            "sameAs": [
              "https://www.facebook.com/people/Mahi-Dental-Clinic/61576158135775/#",
              "https://www.instagram.com/mahi_dental_clinic",
            ]
          })}
        </script>

        {/* Breadcrumb Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.mahidentalclinic.com"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Services",
                "item": "https://www.mahidentalclinic.com/our-services"
              }
            ]
          })}
        </script>

        {/* FAQ Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "Do you provide painless root canal treatment?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Yes, we provide painless root canal treatment using advanced technology and anesthesia."
                }
              },
              {
                "@type": "Question",
                "name": "Do you offer dental implants?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Yes, Mahi Dental Clinic provides high-quality dental implants for missing teeth."
                }
              },
              {
                "@type": "Question",
                "name": "Where is your clinic located?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Our clinic is located at Sector 7, Block C, Gandhinagar, Gujarat 382007."
                }
              },
              {
                "@type": "Question",
                "name": "Do you accept appointments online?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Yes, you can book appointments online through our website or call us directly."
                }
              }
            ]
          })}
        </script>
      </Helmet>

      {/* <Card /> */}
      <HomeBanner />
      <SmartSolar />
      <DigitalSolar />
      <ProjectDetails />
      <ServiceCard />
      <TestimonialCard />
    </>
  );
};

export default Landing;
